import { COLOR1, COLOR2 } from '../../../constants';

export const FeatureScreenStyles = {
  fund_grid_margin: {
    background: '#FFFFFF',
    border: '1px solid #D0D0D0',
    boxShadow: '0px 4px 4px rgb(0 0 0 / 21%)',
    borderRadius: '6px',
    paddingTop: '25px',
    paddingRight: '31px',
    paddingBottom: '32px',
    paddingLeft: '31px',
    opacity: 1,
    '@media (max-width:600px)': {
      border: 'none',
      boxShadow: 'none',
      borderRadius: '0px',
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
  },

  orangeNote: {
    color: '#E37617',
    fontFamily: 'Arial',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
    marginTop: '8px',
    '@media (max-width:600px)': {
      marginTop: '10px',
    },
  },

  error_message: {
    font: 'normal normal normal 14px/16px Arial',
    letterSpacing: '0.1px',
    color: COLOR2,
    opacity: 1,
    position: 'relative',
    top: '3px',
    display: 'block',
  },

  titleborderdeposite: {
    paddingTop: '24px',
    '@media (max-width:600px)': {
      paddingTop: '20px',
    },
  },

  readMore: {
    textDecoration: 'none',
    color: '#661C69',
    fontFamily: 'Arial',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
  },

  titleborderdepositeBor: {
    paddingTop: '24px',
    marginBottom: '26px',
    borderTop: '1px solid #E6E6E6',
    '@media (max-width:600px)': {
      paddingTop: '21px',
      marginBottom: '23px',
    },
  },

  titleborderdepositeBorAnother: {
    paddingTop: '24px',
    borderTop: '1px solid #E6E6E6',
    '@media (max-width:600px)': {
      paddingTop: '23px',
    },
  },

  quesTitleStyle: {
    font: 'normal 700 24px/28px Arial',
    letterSpacing: '0.11px',
    color: COLOR1,
    opacity: 1,
    '@media (max-width:600px)': {
      font: '700 22px/32px Arial',
    },
  },

  quesTitleStyleDeposite: {
    font: 'normal 700 24px/28px TTNormsProBold',
    letterSpacing: '0.11px',
    color: COLOR1,
    opacity: 1,
    '@media (max-width:600px)': {
      font: '700 22px/32px TTNormsProBold',
    },
  },

  radioLayout: {
    marginTop: '34px',
    marginBottom: '30px',
    '@media (max-width:600px)': {
      marginTop: '20px',
      marginBottom: '20px',
    },
  },

  eStatementDesignArial: {
    color: '#000000',
    fontFamily: 'Arial',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
  },

  eStatementDesign: {
    color: '#000000',
    fontFamily: 'TTNormsProBold',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
  },

  radioLayoutDeposite: {
    marginTop: '34px',
    marginBottom: '34px',
    '@media (max-width:600px)': {
      marginTop: '23px',
      marginBottom: '30px',
    },
  },

  debitcard: {
    marginBottom: '20px',
    '@media (max-width:600px)': {
      marginBottom: '12px',
    },
  },

  excessTransfer: {
    marginTop: '24px',
    marginBottom: '30px',
    '@media (max-width:600px)': {
      marginTop: '28px',
      marginBottom: '33px',
      marginLeft: '32px',
    },
  },

  marginStatement: {
    marginTop: '20px',
    marginBottom: '30px',
    '@media (max-width:600px)': {
      marginTop: '27px',
      marginBottom: '30px',
    },
  },

  outerDiv: {
    display: 'flex',
    alignItems: 'flex-start',
    marginTop: '30px',
    marginBottom: '17px',
    marginRight: '14px',
  },

  outerDivAnother: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '30px',
    '@media (max-width:600px)': {
      marginBottom: '23px',
    },
  },

  outerDivStatement: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingBottom: '30px',
    borderBottom: '1px solid #E6E6E6',
  },

  outerDivAutoTransfer: {
    display: 'flex',
    justifyContent: 'flex-start',
  },

  imgDivDesign: {
    width: '24px',
    height: '24px',
    marginRight: '8px',
  },

  mainHeading: {
    color: '#661C69',
    fontFamily: 'Arial',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '20px',
    marginBottom: '20px',
  },

  subHeading: {
    color: '#000000',
    fontFamily: 'Arial',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '10px',
  },

  chkAccountHeading: {
    color: '#000000',
    fontFamily: 'Arial',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '10px',
  },

  onlinetext: {
    fontWeight: 700,
  },

  quesTitleSubHeadingStyle: {
    marginTop: '20px',
    '@media (max-width:600px)': {
      marginTop: '12px',
    },
  },

  textHeadingIMG: {
    color: '#000000',
    fontFamily: 'Arial',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
  },

  radioLabelStyle: {
    marginLeft: '15px',
    font: 'normal 400 16px/18px Arial',
    display: 'inline',
    color: '#000000',
    cursor: 'pointer',
  },

  radioRoot: {
    width: 0,
    height: '19px',
    paddingTop: 0,
    paddingBottom: 0,
    color: '#661c69',
  },
  sameSelectionTextStyle: {
    width: '570.33px',
    // height: '18px',
    fontFamily: 'Arial',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '100%',
    padding: '16px 8px',
    // whiteSpace: 'nowrap',
    '@media (max-width:600px)': {
      width: '271px',
      // height: '36px',
      whiteSpace: 'normal',
    },
  },
  containerStyle: {
    // width: '630px',
    gap: '0px',
  },
  style: {
    // width: '630px',
    // height: '65px',
    margin: '15px 0',
    padding: '0px 8px',
    gap: '0px',
    // '@media (max-width:600px)': {
    //   width: '331px',
    // height: '83px',
    // },
  },
  elementStyle: {
    // width: '582px',
    // height: '65px',
    paddingTop: '8px',
    paddingBottom: '8px',
    gap: '0px',
  },
  depositstyle: {
    width: '109px',
    // height: '19px',
    fontFamily: 'TTNORMSPROBOLD',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '100%',
    textAlign: 'left',
    marginBottom: '6px',
    whiteSpace: 'nowrap',
    '@media (max-width:600px)': {
      width: '109px',
      // height: '19px',
    },
  },
  debitstyle: {
    width: '170px',
    // height: '19px',
    fontFamily: 'TTNORMSPROBOLD',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '100%',
    textAlign: 'left',
    marginBottom: '6px',
    whiteSpace: 'nowrap',
    '@media (max-width:600px)': {
      width: '170px',
      // height: '19px',
    },
  },
  subtextStyle: {
    // width: '582px',
    // height: '18px',
    fontFamily: 'Arial',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '100%',
    color: '#444444',
    padding: '8px 0px',
    '@media (max-width:600px)': {
      // width: '283px',
      // height: '36px',
    },
  },
  containerBoxStyle: {
    // width: '630px',
    // height: '109px',
    padding: '0px 8px',
    gap: '0px',
    // '@media (max-width:600px)': {
    //   width: '331px',
    // height: '161px',
    // },
  },
  statement: {
    width: '594px',
    paddingBottom: '0px',
    marginBottom: '0px',
    gap: '0px',
  },
  stmtstyle: {
    width: '150px',
    // height: '19px',
    // fontFamily: 'TTNORMSPROBOLD',
    fontWeight: 700,
    textAlign: 'center',
  },
  stmtTextStyle: {
    // width: '594px',
    // height: '36px',
    marginBottom: '4px',
    padding: '8px 0px',
    '@media (max-width:600px)': {
      // width: '295px',
      // height: '54px',
    },
  },
  subTextStyle: {
    // width: '594px',
    // height: '28px',
    fontFamily: 'Arial',
    fontWeight: 400,
    fontStyle: 'italic',
    fontSize: '12px',
    lineHeight: '100%',
    color: '#808285',
    paddingTop: '16px',
    '@media (max-width:600px)': {
      // width: '259px',
      // height: '42px',
    },
  },
  boxStyle: {
    // width: '630px',
    // height: '36px',
    display: 'flex',
    gap: '0px',
    borderRadius: '8px',
    paddingLeft: '8px',
  },
  textElementStyle: {
    // width: '594px',
    // height: '36px',
    display: 'flex',
    alignItems: 'center',
    marginTop: '0px',
    paddingTop: '0px',
    // '@media (max-width:600px)': {
    //   width: '290px',
    // height: '54px',
    // },
  },
  borderstyle: {
    borderBottom: '1px solid #E6E6E6',
    padding: '0 0 20px 10px',
    display: 'flex',
    flexDirection: 'column',
    '@media (max-width:600px)': {
      padding: '0px',
    },
  },
  container: {
    width: 630,
    height: 405,
    gap: 2.25,
    transform: 'rotate(0deg)',
    opacity: 1,
    display: 'flex',
  },
  checkbox: {
    width: '36px',
    // height: '36px',
    margin: '0px 3px',
    padding: '0',
    // top: '-20px',
    '@media (max-width:600px)': {
      position: 'relative',
      // top: '-30px',
    },
  },
};
